import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const payLevelsList = (request) => {
    let ENDPOINT = '';
    ENDPOINT = URL_BASE_API+'affiliate/pay-levels/'
    if (request?.data?.column && request.data.column.length > 0) {
      ENDPOINT+= `?column=${request.data.column}`
    }
    return service.get(ENDPOINT);    
}; 

export const payLevelsAdd = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/pay-levels/';
  return service.post(ENDPOINT,request.data);  
};  

export const payLevelsEdit = (request) => {
    let payId = request.data;
    const ENDPOINT = URL_BASE_API+'affiliate/pay-level/'+payId;
    return service.get(ENDPOINT,request.data);
};

export const payLevelsUpdate = (request) => {
  let payId = request.data.payId;
  const ENDPOINT = URL_BASE_API+'affiliate/pay-level/'+payId;
  delete request.data.payId;
  return service.put(ENDPOINT,request.data);
};

export const payLevelsDelete = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/pay-level/'+request.data;
  return service.delete(ENDPOINT);  
};  
